module.exports = __webpack_public_path__ + "static/media/icon-bedroom-3.98b1aa41.svg";